import { render, staticRenderFns } from "./BuildPooledInductions.vue?vue&type=template&id=390fec84&scoped=true"
import script from "./BuildPooledInductions.vue?vue&type=script&lang=js"
export * from "./BuildPooledInductions.vue?vue&type=script&lang=js"
import style0 from "./BuildPooledInductions.vue?vue&type=style&index=0&id=390fec84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390fec84",
  null
  
)

export default component.exports